import { render, staticRenderFns } from "./PremiumModalForm.vue?vue&type=template&id=b12b7d3a&scoped=true"
import script from "./PremiumModalForm.vue?vue&type=script&lang=js"
export * from "./PremiumModalForm.vue?vue&type=script&lang=js"
import style0 from "./PremiumModalForm.vue?vue&type=style&index=0&id=b12b7d3a&prod&lang=css"
import style1 from "./PremiumModalForm.vue?vue&type=style&index=1&id=b12b7d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12b7d3a",
  null
  
)

export default component.exports